import {
  privacyPolicy,
  privacyPolicyMobile,
  termsOfService,
  termsOfServiceMobile,
  howToUse,
  deleteFunction,
} from '../../src/config';
export const API_URL = 'https://money-college-dev.firebaseapp.com/';
export const STRIPE_URL = 'https://api.stripe.com/v1/';
export const MAIL_MAGAZINE_URL =
  'https://yen-money-college.com/neo/services.php';
0;
//TODO: needs to update url once at production
export const PRIVACY_POLICY_URL = privacyPolicy;

export const PRIVACY_POLICY_URL_MOBILE = privacyPolicyMobile;

export const TERMS_OF_SERVICES_URL = termsOfService;

export const TERMS_OF_SERVICES_URL_MOBILE = termsOfServiceMobile;

export const DEV_DELETE_FUNCTIONS_URL = deleteFunction;

export const HOW_TO_USE_URL = howToUse;

/*
  Note: The localhost url is for testing
  Dev url:
  'https://asia-northeast1-money-college-dev-8a907.cloudfunctions.net/app';\
  Localhost url:
  'http://localhost:8083'; */

export const paths: { [key: string]: string } = {
  root: '/',
  home: '/home',
  register: '/sign-up',
  login: '/login',
  logOut: '/logout',
  emailVerificationSent: '/verification-sent',
  verification: '/verification',
  resendVerification: '/resend-verification',
  basicInfo: '/update-profile',
  purchases: '/purchases',
  resetPasswordLink: '/get-reset-password-link',
  resetPassword: '/reset-password',
  resetPasswordLinkSent: '/reset-password-link-sent',
  verifyEmail: '/verify-email',
  recoverEmail: '/recover-email',
  contents: '/contents',
  wpManuals: '/wp-manuals',
  contentsView: '/contents/view',
  mailBox: '/mail',
  purchasePoints: '/purchase-points',
  paymentOptions: '/payment-options',
  paymentConfirmation: '/paymyent-confirmation',
  fx: 'https://cod.expert/investment/',
  virtual: 'https://cod.expert/virtual/',
  overseas: 'https://cod.expert/acount/',
  privacyPolicy: '/privacy-policy',
  termsOfServices: '/terms-of-services',
};

export const urls = {
  todo: {
    getTodos: `${API_URL}/todos`,
  },
};
